
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAHSDChkjho63sS874d1dW6K1i_G9IIOg0",
    authDomain: "reproloom.firebaseapp.com",
    projectId: "reproloom",
    storageBucket: "reproloom.appspot.com",
    messagingSenderId: "941833131770",
    appId: "1:941833131770:web:93f05568ff00a3d3f5db43",
    measurementId: "G-FPL58DXN16"
  };
  
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);